import dayjs                           from 'dayjs';
import AccountSubscriptionModel        from '@models/account/AccountSubscriptionModel';
import RequestChangeSubscriptionModel  from '@models/account/RequestChangeSubscriptionModel';
import { isFreePlan }                  from '@/helpers/subscription/plans';

export type SubscriptionTerm = {
	date: string;
	isEnding: boolean;
};

/**
 * L'échéance à annoncer au client : la date à laquelle son abonnement sera reconduit, ou prendra
 * fin s'il a demandé le retour au plan gratuit.
 *
 * Deux cas n'ont pas d'échéance à annoncer : le plan gratuit, qui ne se facture pas, et une date
 * déjà passée. Ce second cas arrive sur un abonnement payant dont la période est échue et qui n'a
 * plus d'abonnement chez le prestataire : il ne sera pas reconduit, autant ne rien promettre.
 */
export const subscriptionTerm = (
	accountSubscription: AccountSubscriptionModel,
	pendingChange?: RequestChangeSubscriptionModel,
): SubscriptionTerm | undefined => {
	const end = accountSubscription.end;

	if (isFreePlan(accountSubscription.subscription)) return undefined;

	if (!end?.isValid() || end.isBefore(dayjs())) return undefined;

	return {
		date: end.format('DD/MM/YYYY'),
		isEnding: !!pendingChange && isFreePlan(pendingChange.toSubscription),
	};
};
